import { render, staticRenderFns } from "./PermitToWork.vue?vue&type=template&id=53cb0c00&scoped=true"
import script from "./PermitToWork.vue?vue&type=script&lang=js"
export * from "./PermitToWork.vue?vue&type=script&lang=js"
import style0 from "./PermitToWork.vue?vue&type=style&index=0&id=53cb0c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb0c00",
  null
  
)

export default component.exports